/* ============================================================================
   assets/rr-variant-autoselect.js
   RR 25 Aug 2026.

   THE DEFECT. When a customer picks an option that invalidates their current
   combination, the picker re-renders the other groups but never moves the
   selection to a valid value. It leaves a group with NOTHING selected, or with
   a selected value that is now disabled, and the button reads SOLD OUT or
   UNAVAILABLE on a product that has stock.

   MEASURED on the live theme, 25 Aug 2026:

     Element Short, Size = XXL
       Colour re-renders with 2 values and NONE checked, Inseam group vanishes
       entirely, button SOLD OUT. Recovery took 3 clicks by hand:
         Colour = Ocean Blue  -> Inseam reappears with one value, unchecked
         Inseam = 6 inch      -> ADD TO CART
       Behind that dead end: XXL/Ocean Blue/6 inch (4 in stock) and
       XXL/Shark Grey/6 inch (4 in stock).

     Flare Speed Rope Cables, Material = Nylon X
       Nylon X exists in Black only. Purple stays checked AND disabled, id goes
       empty, button UNAVAILABLE. First click on that option is a dead end for
       every customer.
       Material = Nylon Pro does the same and reads SOLD OUT while Black, Grey
       and Red are all in stock.

     Same signature confirmed on Echo Short, Neo T-shirt and Flare Pro v2.0.
     Neo T-shirt Size = M sits in front of 39 units.

   THE FIX. After every picker update, any group that has no checked value, or
   whose checked value is disabled, gets the first selectable value clicked for
   it. That is precisely the recovery a customer has to perform by hand. The
   picker already computes availability correctly - the disabled flags are
   right - it just never acts on them.

   VERIFIED with a real mouse click on live R3.2, Element Short, Size = XXL:
     auto click 1  Color-2 = Ocean Blue   -> Inseam group reappears
     auto click 2  Inseam-3 = 6 inch      -> id 55713017037178, ADD TO CART
   Three clicks of customer work became none. Each correction costs one section
   fetch, so a two-step recovery resolves over a few seconds and the customer
   watches the picker settle rather than hitting a wall.

   SAFETY
   - The group the customer just touched is never overridden.
   - Only a trusted, real user click resets the budget and sets that group;
     clicks this script generates are explicitly not trusted for that purpose,
     which is what stops it chasing its own tail.
   - Bounded: MAX_STEPS corrections per customer action, then it stops.
   - Does nothing on a page where every group already holds a valid, in-stock
     value, so a normal healthy PDP is untouched.
   ============================================================================ */
(function () {
  var MAX_STEPS = 6;
  var SETTLE_MS = 250;

  var steps = 0;
  var lastTouched = null;
  var timer = null;

  function radios() {
    return Array.prototype.slice.call(
      document.querySelectorAll('product-variant-selects input[type="radio"]')
    );
  }

  function groups() {
    var map = {}, order = [], all = radios(), i, r, n;
    for (i = 0; i < all.length; i++) {
      r = all[i];
      n = (r.name || '').trim();
      if (!n) continue;
      if (!map[n]) { map[n] = []; order.push(n); }
      map[n].push(r);
    }
    return { map: map, order: order };
  }

  /* The one group the customer just chose is authoritative. Everything else is
     fair game. */
  function needsFixing() {
    var g = groups(), i, j, name, list, checked, first;
    for (i = 0; i < g.order.length; i++) {
      name = g.order[i];
      if (name === lastTouched) continue;
      list = g.map[name];
      checked = null;
      for (j = 0; j < list.length; j++) { if (list[j].checked) { checked = list[j]; break; } }
      if (checked && !checked.disabled) continue;
      first = null;
      for (j = 0; j < list.length; j++) { if (!list[j].disabled) { first = list[j]; break; } }
      if (first && first !== checked) return first;
    }
    return null;
  }

  function evaluate() {
    if (steps >= MAX_STEPS) return;
    var target = needsFixing();
    if (!target) return;
    steps++;
    target.click();
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(evaluate, SETTLE_MS);
  }

  /* A real customer click resets the budget and marks their group as the one
     we must not touch. Clicks we generate ourselves are not trusted. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || t.tagName !== 'INPUT' || t.type !== 'radio') return;
    if (!t.closest('product-variant-selects')) return;
    if (!e.isTrusted) return;
    steps = 0;
    lastTouched = (t.name || '').trim();
  }, true);

  function start() {
    var host = document.querySelector('product-info') || document.body;
    if (!host) return;
    new MutationObserver(schedule).observe(host, { childList: true, subtree: true });
    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();